import { render, staticRenderFns } from "./labelStageTaskStatusBadge.vue?vue&type=template&id=614f0870&"
import script from "./labelStageTaskStatusBadge.vue?vue&type=script&lang=js&"
export * from "./labelStageTaskStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports